export const setRuleStyle = (editor, selector, style) => {
  const css = editor.CssComposer;

  const rule = css.getRule(selector);

  if (rule) {
    const ruleStyle = rule.get('style');
    rule.set('style', { ...ruleStyle, ...style });
  } else {
    css.setRule(selector, style);
  }
};

/**
 *
 * @param {object} selected Selected component provided by grapesjs
 * @returns {string} Returns src attribute of the image or background-image property
 */
export const getSelectedImageUrl = (selected) => {
  if (!selected) {
    return '';
  }

  const type = selected.get('type');

  if (type === 'image') {
    return selected.get('src');
  }

  if (type === 'icon-wrapper') {
    return selected.get('src') || selected.getStyle()['background-image'] || '';
  }

  return selected.getStyle()['background-image'] || '';
};

/**
 * An utility function to help determine if the selected is a valid anchor node
 * @param {object} rte Grapesjs rich text editor object
 */
export const isValidAnchor = (rte) => {
  const anchor = rte.selection().anchorNode;

  if (!anchor) {
    return false;
  }

  const { parentNode, nextSibling } = anchor;

  return parentNode?.nodeName === 'A' || nextSibling?.nodeName === 'A';
};

export const withWrapper = (component) => {
  return {
    type: 'div-wrapper',
    tagName: 'div',
    attributes: {
      class: 'default-wrapper',
    },
    style: {
      width: '100%',
    },
    selectable: true,
    highlightable: true,
    droppable: false,
    editable: false,
    components: [component],
  };
};

export const replaceDraggedComponentWithWrapper = (editor, selectedItem) => {
  const selectedItemType = selectedItem.get('type');

  const wrappedBlock = withWrapper(selectedItem.clone());
  const replacedBlock = selectedItem.replaceWith(wrappedBlock);

  editor.select(replacedBlock.findType(selectedItemType));
  return replacedBlock;
};

/**
 * Tells whether an image component should be auto-wrapped in a `default-wrapper` div.
 * Bare images are wrapped, while those in `<a>` or `<figure>` tags are skipped to preserve link/caption structures.
 */
export const shouldWrapImageInDefaultWrapper = (imageComponent) => {
  const parent = imageComponent.parent();

  if (!parent) {
    return false;
  }

  return (
    parent.get('type') !== 'div-wrapper' &&
    parent.get('tagName') !== 'a' &&
    parent.get('tagName') !== 'figure'
  );
};
